import useEffectFirst from 'hooks/useEffectFirst';
import useInterval from 'hooks/useInterval';
import { ActiveGamesQuery, rubyQueries } from 'queries';
import { useEffect, useState } from 'react';
import Store, { useStore } from 'stores';

declare global {
  // TODO put this somewhere else
  interface WindowEventMap {
    screenfocus: CustomEvent<boolean>;
  }
}

interface ActiveGamesStoreState {
  subscriberCount: number;
  activeGames: Record<string, ActiveGamesQuery['activeGames'][number]>;
}

const activeGamesStore = new Store<ActiveGamesStoreState>({ subscriberCount: 0, activeGames: {} });

export function useActiveGames(enabled: boolean = true) {
  const [isFocused, setIsFocused] = useState(true);
  const activeGames = useStore(activeGamesStore);

  useEffectFirst(
    isFirst => {
      let subscriberCount = activeGames.subscriberCount;
      if (enabled) {
        subscriberCount++;
      } else if (!isFirst) {
        subscriberCount--;
      }

      activeGamesStore.setState({ subscriberCount });
    },
    [enabled]
  );

  useEffect(() => {
    function handleScreenFocus({ detail: isFocused }: CustomEvent<boolean>) {
      setIsFocused(isFocused);
    }
    window.addEventListener('screenfocus', handleScreenFocus);
    return () => window.removeEventListener('screenfocus', handleScreenFocus);
  }, []);

  function refreshGames() {
    rubyQueries.activeGamesQuery(20).then(({ activeGames }) => {
      const activeGamesMap: ActiveGamesStoreState['activeGames'] = {};

      activeGames.forEach(activeGame => {
        activeGamesMap[activeGame.id] = activeGame;
      });

      activeGamesStore.setState({ activeGames: activeGamesMap });
    });
  }

  useInterval(refreshGames, 30 * 1000, isFocused && activeGames.subscriberCount > 0);

  return activeGames.activeGames;
}
